module.exports = __webpack_public_path__ + "static/media/41_B.1257ef57.png";